import { NSServerCalls } from "./utils/servercalls";
import { URN as NSURN } from './utils/urn';
import { NSMessages } from './utils/messages'

export let NSUserFunctionPermissions = {};

/**
 * 
 * @returns Promise
 */
NSUserFunctionPermissions.init = function()
{


    let o_promise_result = new Promise((resolve, reject) => 
        {
        
            NSUserFunctionPermissionsPrivate.init( resolve );
        }
    );


    this.CONSTS = NSUserFunctionPermissionsPrivate.CONSTS;

//    this.f_has_function_type_DRAW =                     function () { return NSUserFunctionPermissionsPrivate.f_has_function_type_DRAW.apply( NSUserFunctionPermissionsPrivate, arguments ); };
//    this.f_has_function_type_PRINT =                    function () { return NSUserFunctionPermissionsPrivate.f_has_function_type_PRINT.apply( NSUserFunctionPermissionsPrivate, arguments ); };
//    this.f_has_function_type_EXPORT =                   function () { return NSUserFunctionPermissionsPrivate.f_has_function_type_EXPORT.apply( NSUserFunctionPermissionsPrivate, arguments ); };
//    this.f_has_function_type_PDM =                    function () { return NSUserFunctionPermissionsPrivate.f_has_function_type_PDM.apply( NSUserFunctionPermissionsPrivate, arguments ); };
//    this.f_has_function_type_SEARCH =                    function () { return NSUserFunctionPermissionsPrivate.f_has_function_type_SEARCH.apply( NSUserFunctionPermissionsPrivate, arguments ); };
//    this.f_has_function_type_SEARCH_SOLR =                    function () { return NSUserFunctionPermissionsPrivate.f_has_function_type_SEARCH_SOLR.apply( NSUserFunctionPermissionsPrivate, arguments ); };
    this.f_has_function_type_UPDATE =                    function () { return NSUserFunctionPermissionsPrivate.f_has_function_type_UPDATE.apply( NSUserFunctionPermissionsPrivate, arguments ); };
    this.f_has_function_type_READ =                    function () { return NSUserFunctionPermissionsPrivate.f_has_function_type_READ.apply( NSUserFunctionPermissionsPrivate, arguments ); };

//    this.f_has_permission_for_function_type_OBJECT_INFO_and_collection_urn =    function () { return NSUserFunctionPermissionsPrivate.f_has_permission_for_function_type_OBJECT_INFO_and_collection_urn.apply( NSUserFunctionPermissionsPrivate, arguments ); };
    //this.f_has_permission_for_function_type_GSS_EXTENDED_APPLICATION_SCHEMA_LOCAL_and_collection_urn =  function () { return NSUserFunctionPermissionsPrivate.f_has_permission_for_function_type_GSS_EXTENDED_APPLICATION_SCHEMA_LOCAL_and_collection_urn.apply( NSUserFunctionPermissionsPrivate, arguments ); };
    this.f_has_permission_for_function_type_UPDATE_and_collection_urn =         function () { return NSUserFunctionPermissionsPrivate.f_has_permission_for_function_type_UPDATE_and_collection_urn.apply( NSUserFunctionPermissionsPrivate, arguments ); };
//    this.f_has_permission_for_function_type_EXPORT_and_collection_urn =         function () { return NSUserFunctionPermissionsPrivate.f_has_permission_for_function_type_EXPORT_and_collection_urn.apply( NSUserFunctionPermissionsPrivate, arguments ); };
//    this.f_has_permission_for_function_type_SEARCH_SOLR_and_collection_urn =    function () { return NSUserFunctionPermissionsPrivate.f_has_permission_for_function_type_SEARCH_SOLR_and_collection_urn.apply( NSUserFunctionPermissionsPrivate, arguments ); };
    this.f_has_permission_for_function_type_READ_and_collection_urn =           function () { return NSUserFunctionPermissionsPrivate.f_has_permission_for_function_type_READ_and_collection_urn.apply( NSUserFunctionPermissionsPrivate, arguments ); };
 
//	this.f_get_Collections_by_function_type_SEARCH =           function () { return NSUserFunctionPermissionsPrivate.f_get_Collections_by_function_type_SEARCH.apply( NSUserFunctionPermissionsPrivate, arguments ); };
	this.f_get_Collections_by_function_type_READ =           function () { return NSUserFunctionPermissionsPrivate.f_get_Collections_by_function_type_READ.apply( NSUserFunctionPermissionsPrivate, arguments ); };
    


//	this.f_get_function_type_EXPORT =									function () { return NSUserFunctionPermissionsPrivate.f_get_function_type_EXPORT.apply( NSUserFunctionPermissionsPrivate, arguments ); };
//	this.f_get_Collection_by_function_type_EXPORT_and_collection_urn =	function () { return NSUserFunctionPermissionsPrivate.f_get_Collection_by_function_type_EXPORT_and_collection_urn.apply( NSUserFunctionPermissionsPrivate, arguments ); };
	this.f_get_function_type_READ =									function () { return NSUserFunctionPermissionsPrivate.f_get_function_type_READ.apply( NSUserFunctionPermissionsPrivate, arguments ); };
	this.f_get_Collection_by_function_type_READ_and_collection_urn =	function () { return NSUserFunctionPermissionsPrivate.f_get_Collection_by_function_type_READ_and_collection_urn.apply( NSUserFunctionPermissionsPrivate, arguments ); };
	
	
	
	
	window.NSUserFunctionPermissions_ = NSUserFunctionPermissions;
	window.NSUserFunctionPermissionsPrivate_ = NSUserFunctionPermissionsPrivate;

    /*


     */
	

    return o_promise_result;
}

let NSUserFunctionPermissionsPrivate = 
{
	CONSTS: 
	{
		FUNCTION_TYPE: {

            /*
                1	"draw"	false	"Desenho (Independente de Colecções)"
                3	"print"	false	"Impressão (Independente de Colecções)"
                4	"export"	true	"Exportação (Dependente de Colecções)"
                5	"pdm"	false	"PDM (Independente de Colecções)"
                10	"search"	true	"Pesquisa (Dependente de Colecções)"
                11	"search_solr"	true	"Pesquisa Rápida (Dependente de Colecções)"
                20	"update"	true	"Edição (Dependente de Colecções)"
                30	"gss_object_info"	true	"Leitura 1 (Dependente de Colecções)"
                32	"gss_extended_query_local"	true	"Leitura 2 (Dependente de Colecções)"
                33	"gss_extended_application_schema_local"	true	"Leitura 3 (Dependente de Colecções)"
                34	"gss_application_schema_local"	true	"Leitura 4 (Dependente de Colecções)"
                35	"gss_map_local"	false	"Leitura 5 (Independente de Colecções)"
            */

            /*
			DRAW: 1,
			LOCATION: 2,
			PRINT: 3,
			EXPORT: 4,
			PDM: 5,
			SEARCH: 10,
			SEARCH_SOLR: 11,
			SEARCH_LOCATOR: 12,
			UPDATE: 20,
			OBJECT_INFO: 30,
			GSS_EXTENDED_APPLICATION_SCHEMA_LOCAL: 33
            */
            DRAW: 1,
			//LOCATION: 2,
			PRINT: 3,
			EXPORT: 4,
			PDM: 5,
			SEARCH: 10,
			SEARCH_SOLR: 11,
			//SEARCH_LOCATOR: 12,
			UPDATE: 20,
			//OBJECT_INFO: 30,
			//GSS_EXTENDED_APPLICATION_SCHEMA_LOCAL: 33
            READ: 30    //NEW to represent all data read, table data and metadata ---> TO DO TODO AQUIIII UPDATE ADMIN DATABASE
			
		}
		
	},
	
	
	private_objs: {

		/*
		OLD:
		o_func_permissions -> data structure formed by DB "function" and "collection" objects
			->each "function" obj contains a list of "collection" objects
			->the relation between the two tables is n to n, so in this structure there will be repeated collection objects
		NEW:
		o_func_permissions -> data structure formed from DB "function" and "collection" objects
			->this data structure simplifies the recieved data, and stores the allowed function types and respective collections
			->the function_types in the structure are the ones that the user has access to
			->the collections in the structure are the ones that the user has access to
			->some function_types do not have associated collections (ex: "desenho")
			->each "function_type" obj contains a list of "collection" objects
			->the relation between the two tables is n to n, so in this structure there will be repeated collection objects (but not within the same function_type)
		*/
		o_func_permissions: 
		{
			a_function_type: new Array() // ["FunctionType"], 	
		},
		
		o_data_received_from_db: {
			
		}
		
	},
	
	objs: {
		/*
		o_in: { type_id, type_desc}
		*/
		FunctionType : function(o_in)
		{

				this.function_type_id = o_in.type_id;
				this.function_type_desc = o_in.type_desc;
				this.a_collection = []; //[Collection]
		},
		/*
		o_in: { 
			id, 
			geometry_field, 
			data_set_external_name, 
			data_set_internal_name, 
			collection_external_name, 
			collection_internal_name,
			a_desc_field,
			group
			}
		*/
		Collection : function(o_in)
		{

				this.id = o_in.id;
				this.geometry_field = o_in.geometry_field;
				this.data_set_external_name = o_in.data_set_external_name;
				this.data_set_internal_name = o_in.data_set_internal_name;
				this.collection_external_name = o_in.collection_external_name;
				this.collection_internal_name = o_in.collection_internal_name;
				this.a_desc_field = o_in.a_desc_field;
				this.group = o_in.group;
		},
		

		init: function ()
		{
			this.FunctionType.prototype.f_get_collection_by_id = function (i_collection_id)
			{
				var a_ = this.a_collection;
				for(var i=0; i<a_.length;i++)
				{
					var o_i = a_[i];
					if(i_collection_id == o_i.id )
					{
						return o_i;
					}
					
				}
				return null;
			};
			
		}
	},

	/*
	test_data: {
		  "a_rows": [
			{
			  "function_json": {
				"id": 13,
				"type_id": 3,
				"type_desc": "pdm",
				"unique_internal_name": "analise_pdm"
			  },
			  "collection_json": null
			},
			{
			  "function_json": {
				"id": 16,
				"style": {},
				"type_id": 1,
				"type_desc": "search",
				"unique_internal_name": "search_cmc"
			  },
			  "collection_json": {
				"id": 4,
				"geometry_field": "limite",
				"data_set_external_name": "Município",
				"data_set_internal_name": "municipio",
				"collection_external_name": "Feira ou Mercado",
				"collection_internal_name": "mn_feira_mercado"
			  }
			},
			{
			  "function_json": {
				"id": 16,
				"style": {},
				"type_id": 1,
				"type_desc": "search",
				"unique_internal_name": "search_cmc"
			  },
			  "collection_json": {
				"id": 5,
				"geometry_field": "localizacao",
				"data_set_external_name": "Município",
				"data_set_internal_name": "municipio",
				"collection_external_name": "Indústria",
				"collection_internal_name": "mn_industria"
			  }
			}
		  ]
		},
		*/
		
        /**
            @param
             f_cb_in: callback function to be called at the end of processing
        */
		init: function(f_cb_in)
		{
			this.objs.init();
			
			this.f_load_user_permissions_data_(f_cb_in);
		},
		
		f_load_user_permissions_data_: function(f_cb_in)
		{
			var this_ = this;
			
			var f_cb = function(o_res)
			{
				this_.f_load_user_permissions_data_process_res_(o_res);
				f_cb_in();
			}
			

			NSServerCalls.f_get_user_permissions(f_cb);
	
		},
		f_load_user_permissions_data_process_res_: function(o_res)
		{
			var b_error = false;
			try
			{
				this.f_generate_data_structure(o_res);
				
			}
			catch(e)
			{
				b_error = true;
			}
			
			if(b_error)
			{
				var s_msg = "Erro no carregamento dos dados de permissões do utilizador.";
				var i_time_out = 5000;
				NSMessages.f_show_error(s_msg, i_time_out);
				
			}
			
		},		
		
		f_generate_data_structure: function (o_dt_in)
		{
			
			var a_rows = o_dt_in.function_collection_list.a_rows;
			for(var i=0; i<a_rows.length; i++)
			{
				var o_i = a_rows[i];
				var o_f_i = o_i.function_json;
				var o_c_i = o_i.collection_json;
				
				//console.log(o_i);
				
				var o_ft = this.f_get_function_type_by_id(o_f_i.type_id);
				if(o_ft == null)
				{
					this.f_add_new_function_type(o_f_i);
					o_ft = this.f_get_function_type_by_id(o_f_i.type_id);
				}
				
				if(o_c_i != null) //some function_type don't have associated collections
				{
					var o_c = o_ft.f_get_collection_by_id(o_c_i.id);
					if(o_c == null)
					{
						o_c = new this.objs.Collection(o_c_i);
						o_ft.a_collection.push(o_c);
					}	
				}
				
				
			}
			
		},
		
		/*user permissions check function*/
		f_get_function_type_by_id: function(i_id)
		{
			var a_ = this.private_objs.o_func_permissions.a_function_type;
			for(var i=0; i<a_.length;i++)
			{
				var o_i = a_[i];
				if( i_id == o_i.function_type_id )
				{
					return o_i;
				}
				
			}
			return null;
			
		},
		f_add_new_function_type: function(o_function)
		{
			var o_ft = new this.objs.FunctionType(o_function);
			
			var a_ = this.private_objs.o_func_permissions.a_function_type;
			a_.push(o_ft);
			
		},
		f_has_function_type_by_id: function(i_id)
		{
			var o = this.f_get_function_type_by_id(i_id);
			
			var b_res = (o != null)? true : false;
			
			return b_res;
			
		},
		f_get_collection_by_function_type_by_id_and_collection_urn: function(i_ft_id, s_collection_urn)
		{
			var o_ft = this.f_get_function_type_by_id(i_ft_id);
			var o_collection;
			if (o_ft != null)
			{

                var a_feature_urn_info = NSURN.f_get_urn_info( s_collection_urn  );
                var s_schema_internal_name = a_feature_urn_info[1];
                var s_table_internal_name = a_feature_urn_info[2];
				
				var a_collection = o_ft.a_collection;
				for(var i=0; i<a_collection.length; i++)
				{
					var o_col_i = a_collection[i];
					if(o_col_i.data_set_internal_name == s_schema_internal_name
						&& o_col_i.collection_internal_name == s_table_internal_name)
					{
						o_collection = o_col_i;
						break;
					}
				}
			}
			
			
			return o_collection;
			
		},

		//has:
		f_has_function_type_DRAW: function()
		{
			return this.f_has_function_type_by_id(this.CONSTS.FUNCTION_TYPE.DRAW);
		},
		f_has_function_type_LOCATION: function()
		{
			return this.f_has_function_type_by_id(this.CONSTS.FUNCTION_TYPE.LOCATION);
		},
		f_has_function_type_PRINT: function()
		{
			return this.f_has_function_type_by_id(this.CONSTS.FUNCTION_TYPE.PRINT);
		},
		f_has_function_type_EXPORT: function()
		{
			return this.f_has_function_type_by_id(this.CONSTS.FUNCTION_TYPE.EXPORT);
		},
		f_has_function_type_PDM: function()
		{
			return this.f_has_function_type_by_id(this.CONSTS.FUNCTION_TYPE.PDM);
		},
		f_has_function_type_SEARCH: function()
		{
			return this.f_has_function_type_by_id(this.CONSTS.FUNCTION_TYPE.SEARCH);
		},
		f_has_function_type_SEARCH_SOLR: function()
		{
			return this.f_has_function_type_by_id(this.CONSTS.FUNCTION_TYPE.SEARCH_SOLR);
		},
		f_has_function_type_SEARCH_LOCATOR: function()
		{
			return this.f_has_function_type_by_id(this.CONSTS.FUNCTION_TYPE.SEARCH_LOCATOR);
		},
		f_has_function_type_UPDATE: function()
		{
			return this.f_has_function_type_by_id(this.CONSTS.FUNCTION_TYPE.UPDATE);
		},
		f_has_function_type_OBJECT_INFO: function()
		{
			return this.f_has_function_type_by_id(this.CONSTS.FUNCTION_TYPE.OBJECT_INFO);
		},
		f_has_function_type_READ: function()
		{
			return this.f_has_function_type_by_id(this.CONSTS.FUNCTION_TYPE.READ);
		},
		
		f_has_permission_for_function_type_OBJECT_INFO_and_collection_urn: function(s_collection_urn)
		{
			var o_collection_info = this.f_get_Collection_by_function_type_OBJECT_INFO_and_collection_urn(s_collection_urn);
			var b_has_permission = (o_collection_info != null)? true : false;
			return b_has_permission;
		},
		f_has_permission_for_function_type_GSS_EXTENDED_APPLICATION_SCHEMA_LOCAL_and_collection_urn: function(s_collection_urn)
		{
			var o_collection_info = this.f_get_Collection_by_function_type_GSS_EXTENDED_APPLICATION_SCHEMA_LOCAL_and_collection_urn(s_collection_urn);
			var b_has_permission = (o_collection_info != null)? true : false;
			return b_has_permission;
		},
		f_has_permission_for_function_type_UPDATE_and_collection_urn: function(s_collection_urn)
		{
			var o_collection_info = this.f_get_Collection_by_function_type_UPDATE_and_collection_urn(s_collection_urn);
			var b_has_permission = (o_collection_info != null)? true : false;
			return b_has_permission;
		},
		f_has_permission_for_function_type_EXPORT_and_collection_urn: function(s_collection_urn)
		{
			var o_collection_info = this.f_get_Collection_by_function_type_EXPORT_and_collection_urn(s_collection_urn);
			var b_has_permission = (o_collection_info != null)? true : false;
			return b_has_permission;
		},
		f_has_permission_for_function_type_SEARCH_SOLR_and_collection_urn: function(s_collection_urn)
		{
			var o_collection_info = this.f_get_Collection_by_function_type_SEARCH_SOLR_and_collection_urn(s_collection_urn);
			var b_has_permission = (o_collection_info != null)? true : false;
			return b_has_permission;
		},
		f_has_permission_for_function_type_READ_and_collection_urn: function(s_collection_urn)
		{
			var o_collection_info = this.f_get_Collection_by_function_type_READ_and_collection_urn(s_collection_urn);
			var b_has_permission = (o_collection_info != null)? true : false;
			return b_has_permission;
		},
		
		
		
		//get:
		f_get_function_type_EXPORT: function()
		{
			return this.f_get_function_type_by_id(this.CONSTS.FUNCTION_TYPE.EXPORT);
		},
		f_get_Collection_by_function_type_EXPORT_and_collection_urn: function(s_collection_urn)
		{
			return this.f_get_collection_by_function_type_by_id_and_collection_urn(this.CONSTS.FUNCTION_TYPE.EXPORT, s_collection_urn);
		},
		f_get_Collection_by_function_type_OBJECT_INFO_and_collection_urn: function(s_collection_urn)
		{
			return this.f_get_collection_by_function_type_by_id_and_collection_urn(this.CONSTS.FUNCTION_TYPE.OBJECT_INFO, s_collection_urn);
		},
		f_get_Collection_by_function_type_GSS_EXTENDED_APPLICATION_SCHEMA_LOCAL_and_collection_urn: function(s_collection_urn)
		{
			return this.f_get_collection_by_function_type_by_id_and_collection_urn(this.CONSTS.FUNCTION_TYPE.GSS_EXTENDED_APPLICATION_SCHEMA_LOCAL, s_collection_urn);
		},
		f_get_function_type_SEARCH: function()
		{
			return this.f_get_function_type_by_id(this.CONSTS.FUNCTION_TYPE.SEARCH);
		},
		f_get_Collection_by_function_type_SEARCH_and_collection_urn: function(s_collection_urn)
		{
			return this.f_get_collection_by_function_type_by_id_and_collection_urn(this.CONSTS.FUNCTION_TYPE.SEARCH, s_collection_urn);
		},
		f_get_Collections_by_function_type_SEARCH: function()
		{
			var o_ft_Search = this.f_get_function_type_SEARCH();
			return o_ft_Search.a_collection;
		},
		f_get_function_type_READ: function()
		{
			return this.f_get_function_type_by_id(this.CONSTS.FUNCTION_TYPE.READ);
		},
		f_get_Collections_by_function_type_READ: function()
		{
			var o_ft_Search = this.f_get_function_type_READ();
			return o_ft_Search.a_collection;
		},
		f_get_Collection_by_function_type_UPDATE_and_collection_urn: function(s_collection_urn)
		{
			return this.f_get_collection_by_function_type_by_id_and_collection_urn(this.CONSTS.FUNCTION_TYPE.UPDATE, s_collection_urn);
		},
		f_get_Collection_by_function_type_SEARCH_SOLR_and_collection_urn: function(s_collection_urn)
		{
			return this.f_get_collection_by_function_type_by_id_and_collection_urn(this.CONSTS.FUNCTION_TYPE.SEARCH_SOLR, s_collection_urn);
		},
		f_get_Collection_by_function_type_READ_and_collection_urn: function(s_collection_urn)
		{
			return this.f_get_collection_by_function_type_by_id_and_collection_urn(this.CONSTS.FUNCTION_TYPE.READ, s_collection_urn);
		}
		
		
	
}